<!-- left-navigation.component.html -->
<div class="left-navigation">
  <ul class="nav flex-column">
    <ng-container *ngFor="let item of navItems">
      <!-- Parent item -->
      <li class="nav-item">
        <a
          [routerLink]="item.isCategory ? null : item.path"
          [class.active]="isActive(item.path)"
          class="nav-link"
          [ngClass]="{
            'has-children': item.children && item.children.length > 0,
            'category-link': item.isCategory
          }"
          (click)="navigateTo(item, $event)"
        >
          <!-- Chevron on the left for categories -->
          <span *ngIf="item.isCategory && item.children && item.children.length > 0"
                class="chevron-left"
                [ngClass]="{'expanded': item.isExpanded}"
                (click)="onChevronClick(item, $event)">
            <i class="fas fa-chevron-right"></i>
          </span>

          <span>{{ item.displayKey | translate }}</span>
        </a>

        <!-- Category children (collapse/expand) -->
        <ul *ngIf="item.isCategory && item.children && item.children.length > 0 && item.isExpanded"
            class="nav flex-column sub-nav">
          <li *ngFor="let child of item.children" class="nav-item">
            <a
              [routerLink]="child.isCategory ? null : child.path"
              [class.active]="isActive(child.path)"
              class="nav-link"
              [ngClass]="{'category-link': child.isCategory}"
              (click)="navigateTo(child, $event)"
            >
              <!-- Chevron on the left for child categories -->
              <span *ngIf="child.isCategory && child.children && child.children.length > 0"
                    class="chevron-left"
                    [ngClass]="{'expanded': child.isExpanded}">
                <i class="fas fa-chevron-right"></i>
              </span>

              <span>{{ child.displayKey | translate }}</span>
            </a>

            <!-- Sub-items of category children (always visible) -->
            <ul *ngIf="!child.isCategory && child.children && child.children.length > 0"
                class="nav flex-column sub-item-nav">
              <li *ngFor="let subItem of child.children" class="nav-item">
                <a
                  href="javascript:void(0)" 
                  [class.active]="isSubItemActive(subItem)"
                  class="nav-link sub-item-link"
                  (click)="navigateTo(subItem, $event)"
                >
                  <span>{{ subItem.displayKey | translate }}</span>
                </a>
              </li>
            </ul>
          </li>
        </ul>

        <!-- Sub-item children (always visible) -->
        <ul *ngIf="!item.isCategory && item.children && item.children.length > 0"
            class="nav flex-column sub-item-nav">
          <li *ngFor="let subItem of item.children" class="nav-item">
            <a
              href="javascript:void(0)" 
              [class.active]="isSubItemActive(subItem)"
              class="nav-link sub-item-link"
              (click)="navigateTo(subItem, $event)"
            >
              <span>{{ subItem.displayKey | translate }}</span>
            </a>
          </li>
        </ul>
      </li>
    </ng-container>
  </ul>
</div>
